module.exports = __webpack_public_path__ + "static/img/lifestyle_07.a27f7b19.jpg";